import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import URLs from '../../utils/url';
import logo from '../../assets/images/LB_Logogold.png';
import makingVideo from '../../assets/images/custom-mens-wedding-rings.mp4';

import './index.scss';

interface IProps {
  match: any;
  location: any;
  history: any;
}

const Homepage = (props: IProps) => {
  const [buildUrl, setBuildUrl] = useState('');
  useEffect(() => {
    let URL = URLs.BASE_PRODUCT_URL;
    URL = '/helzberg' + URL;
    URL = `${props.location.pathname}?ring_url=${encodeURIComponent(URL)}`;
    setBuildUrl(URL);
  }, [props.location]);
  return (
    <div className="tw-fixed tw-bg-white">
      <img className="gold-logo" alt="Lashbrook Logo" src={logo}></img>
      <video
        className="hero-video hidden-sm"
        style={{
          width: '100vw',
          minHeight: '100vh',
          margin: '0 auto',
          display: 'block',
          backgroundSize: 'cover',
          backgroundColor: 'black'
        }}
        src={makingVideo}
        autoPlay
        loop
        muted
      />
      <section className="home-content tw-absolute xs:tw-top-[0] xs:tw-bottom-0 md:tw-top-[15%] md:tw-bottom-[unset]">
        <h2 className="md:tw-text-4xl">QUALITY. HANDMADE. RINGS.</h2>
        <Link to={buildUrl}>
          <button className="tw-uppercase tw-cursor-pointer">Build your own</button>
        </Link>
      </section>
    </div>
  );
};

export default Homepage;
